<h1 mat-dialog-title>
    {{ title }}
  </h1>
    <form [formGroup]="formControl" fxLayout="row wrap" fxLayoutAlign="start start" class="px-8 pt-8">
      <div fxFlex="100" [ngSwitch]="type">
        <div *ngSwitchCase="'select'" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="flex-start flex-start" class="m-8">
          <mat-label fxFlex="100"   >{{'DIALOGS.REFUSE.MOTIVE' | translate}}</mat-label>
          <mat-form-field  fxFlex="100"   appearance="outline" floatLabel="always">
              <mat-select formControlName="motive" >          
                  <mat-option *ngFor="let item of motivesData" [value]="item">
                      <span>{{item.description}}</span>
                  </mat-option>
              </mat-select>
          </mat-form-field>
          <ng-container *ngIf="formControl.controls.motive.touched"> 
            <mat-error *ngIf="formControl.controls.motive.hasError('required')">{{'INPUT.REQUIRED' | translate}}</mat-error>                                   

          </ng-container>       
        </div>
      </div>
      <div fxFlex="100" fxLayout="row wrap" fxLayoutAlign="flex-start flex-start"  class="m-8">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100%">
            <textarea matInput rows="6" #textarea formControlName="comment" maxlength="maxLenght" placeholder="{{placeholder}}">              
            </textarea>      
        </mat-form-field>
        <ng-container *ngIf="formControl.get('comment').valid">
            <div fxLayout="row" fxFlex="100%" fxLayoutAlign="flex-end" class="input-text-hint">
                <!-- <mat-hint>{{textInput.value.length}} / {{maxLength}}</mat-hint> -->
                <mat-hint align="end" style="font-size: smaller;">{{textarea.value.length}} / {{maxLength}}</mat-hint>    
            </div> 
        </ng-container>

<!-- <ng-container *ngIf="formGroup.get(controlName).valid">
            <div fxLayout="row" fxLayoutAlign="flex-end" class="input-text-hint">
                <mat-hint>{{textInput.value.length}} / {{maxLength}}</mat-hint>
            </div> 
        </ng-container>
        <ng-container *ngIf="formGroup.get(controlName).touched"> 
            <mat-error *ngIf="formGroup.get(controlName).hasError('required')">{{'INPUT.REQUIRED' | translate}}</mat-error> 
        </ng-container>  -->

        <ng-container *ngIf="formControl.controls.comment.touched"> 
          <mat-error *ngIf="formControl.controls.comment.hasError('required')">{{'INPUT.REQUIRED' | translate}}</mat-error>
          <mat-error *ngIf="formControl.controls.comment.hasError('maxlength')">{{'INPUT.MAXLENGTH' | translate}}</mat-error>                                    
        </ng-container>    
      </div>
    </form>
  
  
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="onDismiss()">
      <span class="mx-8">{{'DIALOGS.ACTIONS.CANCEL' | translate}}</span>
    </button>
    <button mat-raised-button color="accent" class="ml-8"
      [disabled]="formControl.pristine || this.formControl.invalid" 
      (click)="onConfirm()">
      <span class="mx-8">{{'DIALOGS.ACTIONS.ACCEPT' | translate}}</span>
    </button>
  </div>
